import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Autosuggest from "react-autosuggest";
import { searchNonprofitHandler } from "../../../redux/slices/donationCamp/searchNonprofit-slice";
import { SearchSuggestionProp } from "../../../utils/types";
import { useNavigate } from "react-router-dom";

interface AutoSearchProp {
    searchValue: string;
    setZipCodeVal: any;
    zipCodeVal: any;
    setSearchValue: (val: string) => void;
    searchSlug?: string;
    placeholder?: string;
    setSearchSlug: (val: string) => void;
}

const AutosuggestSearch = ({ searchValue, setSearchValue, placeholder, searchSlug, setSearchSlug, setZipCodeVal, zipCodeVal }: AutoSearchProp) => {

    const searchNonprofitList = useSelector((state: any) => state?.searchNonprofit?.data?.results);
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [suggestions, setSuggestions] = useState<Array<any>>([]);


    useEffect(() => {
        if (searchValue.trim() || zipCodeVal) {
            const debounceTimeout = setTimeout(() => {
                dispatch(searchNonprofitHandler(searchValue, zipCodeVal));
            }, 500);
            return () => clearTimeout(debounceTimeout);
        }
    }, [dispatch, searchValue, zipCodeVal]);

    useEffect(() => {
        if (searchNonprofitList?.length > 0) {
            setSuggestions(searchNonprofitList);
        } else {
            setSuggestions([]);
        }
    }, [searchNonprofitList]);
    // useEffect(() => {
    //     let searchTimeOut: NodeJS.Timeout
    //     if (searchValue || zipCodeVal) {
    //         searchTimeOut = setTimeout(() => {
    //             dispatch(searchNonprofitHandler(searchValue, zipCodeVal));
    //         }, 500);
    //     }
    //     return () => { clearTimeout(searchTimeOut) }
    // }, [dispatch, searchValue]);


    const getSuggestions = async () => {
        const option = searchNonprofitList ?? []
        return option
    };


    const onSuggestionsFetchRequested = async () => {
        const suggestions = await getSuggestions();
        setSuggestions(suggestions);
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const onSuggestionSelected = (event: React.SyntheticEvent, { suggestion }: { suggestion: SearchSuggestionProp }) => {
        event.preventDefault();
        setSearchValue(suggestion.nonprofit?.name || `${suggestion.city.name}, ${suggestion.state.name}`);
        setSuggestions([]);
    };

    const onChange = (event: React.FormEvent, { newValue }: { newValue: string }) => {
        setSearchValue(newValue)
    };

    const getSuggestionValue = (suggestion: SearchSuggestionProp) => {
        return `${suggestion.city.name}, ${suggestion.state.name}`;
    };
    const handleOrgNavigation = (suggestion: any) => {
        navigate(`/org/${suggestion.nonprofit.slug}`)
        setSearchValue(suggestion.nonprofit.slug)
    }

    const renderSuggestion = (suggestion: SearchSuggestionProp) => {
        const handleOrgClick = (event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            typeof localStorage !== "undefined" && localStorage.removeItem("search")
            handleOrgNavigation(suggestion);
        };

        const handleCityClick = (event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            typeof localStorage !== "undefined" && localStorage.removeItem("search");
            if (suggestion.city && suggestion.state) {
                setSearchValue(`${suggestion.city.name}, ${suggestion.state.name}`)
                // navigate(`/city/${suggestion.city.slug}/${suggestion.state.name}`);
                setSuggestions([]);
            }
        };


        return (
            <div>
                <a href="#!" className="link-content" onClick={handleOrgClick}>
                    {suggestion?.nonprofit?.name}{" "}
                </a>
                <a href="#!" onClick={handleCityClick}>
                    {suggestion?.city?.name}, {suggestion?.state?.name}
                </a>
            </div>
        );
    };


    const inputProps = {
        placeholder: placeholder || 'Org, City & State Search...',
        value: searchValue,
        name: "search",
        onChange: onChange,
        onBlur: onSuggestionsClearRequested,
    };
    return (

        <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}

        />
    )
}

export default AutosuggestSearch
